import React, {useMemo} from 'react';
import {useRouter} from "next/router";
import Button from "@/components/common/Buttons/Button";
import {BUTTON_TYPE, PAGES} from "@/constants";

const WwdLink = ({ ...props }) => {
	const { locale } = useRouter()
	const wwdText = useMemo(() => {
		switch (locale){
			case 'pl':
				return 'Co robimy?'
			case 'en':
				return 'What we do?'
			case 'de':
				return 'WAS WIR TUN'
			default:
				return 'Co robimy?'
		}
	},[locale])
	return (
		<Button
			as="link"
			href={`/${PAGES.WHAT_WE_DO}`}
			animation={false}
			type={BUTTON_TYPE.UNSTYLED}
			font="borna"
			typo={50}
			{...props}
		>
			{wwdText.toUpperCase()}
		</Button>
	)
};

export default WwdLink;
